import { createApp } from 'vue';

import 'bootstrap/dist/css/bootstrap-grid.min.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'simplebar-vue/dist/simplebar.min.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';

import '@/assets/fonts/weather-icons/css/weather-icons.min.css';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
	BButton,
	BCard,
	BCardBody,
	BCardHeader,
	BCardTitle,
	BCol,
	BContainer,
	BDropdown,
	BDropdownItem,
	BLink,
	BRow,
} from 'bootstrap-vue-next';
import I18NextVue from 'i18next-vue';

import { localize, setLocale } from '@vee-validate/i18n';
import zh_TW from '@vee-validate/i18n/dist/locale/zh_TW.json';
import * as AllRules from '@vee-validate/rules';
import { configure, defineRule } from 'vee-validate';

import { $color } from '@/utils/colors';
import Vue3SimpleAlert from '@/utils/vue3-simple-alert';
import Notifications from '@kyvg/vue3-notification';

import VueApexCharts from 'vue3-apexcharts';
import Clipboard from 'vue3-clipboard';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import '@/styles/shared/EasyDataTableExpandCompact.scss';
// import CKEditor from '@ckeditor/ckeditor5-vue';

import jquery from 'jquery';
import mitt from 'mitt';

import App from './App.vue';
import i18next from './i18n';
import './registerServiceWorker';
import router from './router';
import store from './store';

import { apiServer, appName, webServer } from './connect';

const app = createApp(App);

// 註冊全域變數
const appname = appName();
const server = apiServer();
const website = webServer();
const language = 'tw';
// eslint-disable-next-line no-undef
const ogzuid = typeof YSS_DSE_OGZUID !== 'undefined' ? YSS_DSE_OGZUID : '';
// eslint-disable-next-line no-undef
const evid = typeof YSS_DSE_EVID !== 'undefined' ? YSS_DSE_EVID : '';
console.log(
	`main, appname=${appname}, server=${server}, website=${website}, language=${language}, ogzuid=${ogzuid}, evid=${evid}`
);

app.config.globalProperties.$appname = appname;
app.config.globalProperties.$server = server;
app.config.globalProperties.$website = website;
app.config.globalProperties.$language = language;
Object.defineProperties(app.config.globalProperties, {
	$ogzuid: {
		get: () => store.state.settings.auth.accessOUID || ogzuid || '',
	},
	$evid: {
		get: () => store.state.db.evid || evid || '',
	},
});
app.config.globalProperties.$jquery = jquery;
app.config.globalProperties.$emitter = mitt();
app.config.globalProperties.$color = $color;
app.config.globalProperties.$t = (...args) => i18next.t(...args);

// 註冊全域元件
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('EasyDataTable', Vue3EasyDataTable);
app.component('BButton', BButton);
app.component('BCard', BCard);
app.component('BCardBody', BCardBody);
app.component('BCardHeader', BCardHeader);
app.component('BCardTitle', BCardTitle);
app.component('BCol', BCol);
app.component('BContainer', BContainer);
app.component('BDropdown', BDropdown);
app.component('BDropdownItem', BDropdownItem);
app.component('BLink', BLink);
app.component('BRow', BRow);

// 註冊插件（router 和 store 必須在 i18next 初始化前註冊）
app.use(VueApexCharts);
app.use(VueSweetalert2);
app.use(Notifications);
// app.use(CKEditor)
app.use(Clipboard, {
	autoSetContainer: true,
	appendToBody: true,
});

// 設定 vee-validate
// Object.keys(AllRules).forEach(rule => {
// 	defineRule(rule, AllRules[rule]);
// });

/**
 * Registration of all global validators.
 */
Object.keys(AllRules).forEach(rule => {
	if (typeof AllRules[rule] === 'function') {
		defineRule(rule, AllRules[rule]);
	}
});

configure({
	validateOnInput: true, // 調整為即時驗證
	generateMessage: localize({
		zh_TW,
	}),
});

setLocale('zh_TW');

// 設定 i18next
app.use(I18NextVue, { i18next });

// 在main.js中設定i18next初始化完成後，再設定vue3-simple-alert
i18next.on('initialized', options => {
	// 設定 vue3-simple-alert
	// console.log('i18next is ready, text=', i18next.t('platform.dialog.confirm.ok'));

	// 設定 vue3-simple-alert, 一開始就設定好多語系的按鈕文字
	const alertOptions = {
		title: '<h6>YouEvent365</h6>',
		showCancelButton: false,
		buttonsStyling: false,
		customClass: {
			popup: 'swal-vuestudio',
			confirmButton: 'btn btn-primary swal-vuestudio__confirm',
			cancelButton:
				'btn btn-outline-secondary swal-vuestudio__cancel',
		},
		// confirmButtonText: i18next.t('platform.dialog.confirm.ok'),
		// cancelButtonText: i18next.t('platform.dialog.confirm.cancel'),
		confirmButtonText: 'OK',
		cancelButtonText: 'Cancel',
	};

	app.use(Vue3SimpleAlert, alertOptions);

	// 避免在 i18next 初始化晚於app.mount, 所以把最後的use跟mount放在i18next 初始化完成事件裡
	app.use(store).use(router);
	app.mount('#app');
});

export default app;
